/* eslint-disable no-return-assign */
/* eslint-disable react/prop-types */
import React from 'react'

export const ChartWrapper = ({ children, title }) => {
  const containerStyle = {
    padding: '20px',
    margin: '50px auto',
    width: '80%',
    height: '500px',
    maxWidth: '1000px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
    textAlign: 'center',
    transition: 'all 0.3s ease-in-out',
    overflow: 'hidden',
    background: 'linear-gradient(to right, #222236, #3b3b5c)',
    color: '#f8f8f8',
    textShadow: '1px 1px 2px rgba(50, 50, 50, 0.8)'
  }

  // Function to handle mouse over
  const handleMouseOver = (e) => {
    e.currentTarget.style.transform = 'scale(1.05)'
    e.currentTarget.style.boxShadow = '0 12px 40px rgba(0, 0, 0, 0.4)'
  }

  // Function to handle mouse out
  const handleMouseOut = (e) => {
    e.currentTarget.style.transform = 'scale(1)'
    e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.2)'
  }

  return (
    <div style={containerStyle} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
      <div style={{ fontSize: '1.8rem', transition: 'color 0.3s ease, transform 0.3s ease', cursor: 'pointer' }}> {title} </div>
      <div style={{ width: '100%', height: '90%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        {children}
      </div>
    </div>
  )
}
